/** Functions **/
var colors = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"lightness":19}]},{"featureType":"transit","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"transit.line","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.bus","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}];


function handle_loading_msg_button(form,loading)
{
    var submit_button = form.find('button[type="submit"]');
    var span_loading_msg = submit_button.data('msg_loading');
    var span_msg = submit_button.data('msg_default');
	if (loading)
	{
	    submit_button.addClass('disabled');
	}
	else
	{
	    submit_button.removeClass('disabled');
	}

	// submit_button.parent().find('span').text(span_msg);
	submit_button.text(span_loading_msg);

}

function studentform_success(form, data)
{
	window.location = form.attr('action');
}

function newsletterform_success(form, data) {
	form.fadeOut(200, function() {

        // jQuery('html,body').on("scroll mousedownzo wheel DOMMouseScroll mousewheel keyup touchmove", function() {
        //     jQuery("html,body").stop();
        // });

        // jQuery('html,body').animate({
        //     scrollTop: form.parent().offset().top
        // }, 400, function(){
        //     jQuery("html,body").off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
        // });


    	jQuery(this).before('<div id="msg_success" style="display:none;" class="Alert has-success">'+data.message+'</div>');
    	jQuery('#msg_success').fadeIn(200);
    });
}

function contactform_success(form, data)
{
	jQuery('.contactformType').fadeOut(200);
	form.fadeOut(200, function() {

        jQuery('html,body').on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function() {
            jQuery("html,body").stop();
        });

        jQuery('html,body').animate({
			scrollTop: form.parents('section.o-section').offset().top - jQuery('.c-header').height()
        }, 400, function(){
            jQuery("html,body").off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
        });


    	jQuery(this).before('<div id="msg_success" style="display:none;" class="Alert has-success">'+data.message+'</div>');
    	jQuery('#msg_success').fadeIn(200);
    });
}

function submitplanificateur_form()
{
	jQuery('.js-planificateur').submit();
}

function showPosition(position) {
    x.innerHTML = "Latitude: " + position.coords.latitude +
    "<br>Longitude: " + position.coords.longitude;
}

function initGoogleMapApi()
{
    // var map = new google.maps.Map(document.getElementById('map'), {
    //   center: {lat: -33.8688, lng: 151.2195},
    //   zoom: 13
    // });

    initMap();

    jQuery('.js-location-input').each(function(index, el) {
    	// var input = document.getElementById('input_location_finder_start');
    	var strictBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(46.276780, -72.784901),
        new google.maps.LatLng(46.483009, -72.398611));

    	var options = {
			location: {lat: 46.354680, lng: -72.583787},
			radius: 10,
			bounds: strictBounds,
			strictbounds: true,
			fields: ["address_components"],
			componentRestrictions: { country: "ca" },
		};

		var autocomplete = new google.maps.places.Autocomplete(el, options);
// console.log(el)
		if (el.dataset['mapping']) {
			setTimeout(() => {
				el.setAttribute("autocomplete", "nope");
			}, 500);
			var mapping = JSON.parse(el.dataset['mapping']);
			autocomplete.addListener('place_changed', function (e) {
				console.log('mapping', mapping);
				address = autocomplete.getPlace();
				console.log('address', address);

				if(address.address_components && address.address_components.length > 0){
					var address_components = address.address_components;
					if (mapping.address) {
						var result = '';
						var found = address_components.find((item) => item.types.includes('street_number'));
						if (found) result += found.long_name + ' ';
						found = address_components.find((item) => item.types.includes('route'));
						if (found) result += found.long_name + ' ';

						if(result!='')
						{
							jQuery('#'+mapping.address).val(result);
							jQuery('#'+mapping.address).addClass('-filled')
						}
					}
					if (mapping.city) {
						var result = '';
						var found = address_components.find((item) => item.types.includes('locality'));
						if (found) result += found.long_name + ' ';

						if (result != '')
						{
							jQuery('#'+mapping.city).val(result);
							jQuery('#'+mapping.city).addClass('-filled')
						}
					}
					if (mapping.postal_code) {
						var result = '';
						var found = address_components.find((item) => item.types.includes('postal_code'));
						if (found) result += found.long_name + ' ';

						if (result != '')
						{
							jQuery('#'+mapping.postal_code).val(result);
							jQuery('#'+mapping.postal_code).addClass('-filled')
						}
					}
					if (mapping.state) {
						var result = '';
						var found = address_components.find((item) => item.types.includes('administrative_area_level_1'));
						if (found) result += found.long_name + ' ';

						if (result != '')
						{
							jQuery('#'+mapping.state).val(result);
							jQuery('#'+mapping.state).addClass('-filled')
						}
					}
					if (mapping.country) {
						var result = '';
						var found = address_components.find((item) => item.types.includes('country'));
						if (found) result += found.long_name + ' ';

						if (result != '')
						{
							jQuery('#' + mapping.country).val(result);
							jQuery('#'+mapping.country).addClass('-filled')
						}
					}
				}
			})

		}
    });

    initDirection();
    initCircuit();

    // var types = document.getElementById('type-selector');
    // map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
    // map.controls[google.maps.ControlPosition.TOP_LEFT].push(types);

    // autocomplete.bindTo('bounds', map);

    // var infowindow = new google.maps.InfoWindow();
    // var marker = new google.maps.Marker({
    //   map: map,
    //   anchorPoint: new google.maps.Point(0, -29)
    // });

    // autocomplete.addListener('place_changed', function() {
    //   infowindow.close();
    //   marker.setVisible(false);
    //   var place = autocomplete.getPlace();
    //   if (!place.geometry) {
    //     // User entered the name of a Place that was not suggested and
    //     // pressed the Enter key, or the Place Details request failed.
    //     window.alert("No details available for input: '" + place.name + "'");
    //     return;
    //   }

      // If the place has a geometry, then present it on a map.
      // if (place.geometry.viewport) {
      //   map.fitBounds(place.geometry.viewport);
      // } else {
      //   map.setCenter(place.geometry.location);
      //   map.setZoom(17);  // Why 17? Because it looks good.
      // }
      // marker.setIcon(/** @type {google.maps.Icon} */({
      //   url: place.icon,
      //   size: new google.maps.Size(71, 71),
      //   origin: new google.maps.Point(0, 0),
      //   anchor: new google.maps.Point(17, 34),
      //   scaledSize: new google.maps.Size(35, 35)
      // }));
      // marker.setPosition(place.geometry.location);
      // marker.setVisible(true);

      // var address = '';
      // if (place.address_components) {
      //   address = [
      //     (place.address_components[0] && place.address_components[0].short_name || ''),
      //     (place.address_components[1] && place.address_components[1].short_name || ''),
      //     (place.address_components[2] && place.address_components[2].short_name || '')
      //   ].join(' ');
      // }

      // infowindow.setContent('<div><strong>' + place.name + '</strong><br>' + address);
      // infowindow.open(map, marker);
    // });
}

function initDirection()
{
	if (jQuery('.js-planificateur').length > 0)
	{
		// window.directionsDisplay = new google.maps.DirectionsRenderer({
		//     polylineOptions: {
		//       	strokeColor: "red",
		//         strokeOpacity: 0.8,
  //   			strokeWeight: 5,
		//     }
		// });
		window.directionsDisplay = new google.maps.DirectionsRenderer;
		window.directionsService = new google.maps.DirectionsService;
		// var map = new google.maps.Map(document.getElementById('map'), {
		//   zoom: 7,
		//   center: {lat: 41.85, lng: -87.65}
		// });
		var map = new google.maps.Map(jQuery(".mapPlanificateur")[0], {
			zoom: 12,
			center: {lat: 46.354680, lng: -72.583787},
			scrollwheel: false,
			disableDefaultUI: false,
			styles : colors
		});

		window.directionsDisplay.setMap(map);
		window.directionsDisplay.setPanel(jQuery('.detailDirection')[0]);

		function calculateAndDisplayRoute(depart, arrivee, datetime, routingPreference)
		{
			var transitOptions = {
				    departureTime: new Date(datetime),
				    modes: ['BUS']
			}

			if (routingPreference != 'BEST_ROUTE')
			{
				transitOptions.routingPreference = routingPreference;
			}

			window.directionsService.route({
			  origin: depart,
			  destination: arrivee,
			  travelMode: 'TRANSIT',
			  transitOptions: transitOptions,
			  provideRouteAlternatives: true,

			}, function(response, status) {
			  if (status === 'OK')
			  {
			    window.directionsDisplay.setDirections(response);
			  }
			  else
			  {
			    // alert('Un problème est survenu lors de la planification du parcours: ' + status);
	          	jQuery('.js-planificateur').find('.error-custom').remove();
	          	jQuery('.js-planificateur').append('<label class="filled error-custom has-error"><span class="parsley-required">'+message_error_planification+'</span></label>');
			  }
			});
		}

	    jQuery('.js-planificateur').submit(function(e) {
	    	e.preventDefault();
	    	var depart = jQuery(this).find('input[name="lieu_depart"]').val();
	    	var arrivee = jQuery(this).find('input[name="lieu_arrivee"]').val();
	    	var date = jQuery(this).find('[name="date_planificateur"]').val();
	    	var time = jQuery(this).find('input[name="time_planificateur"]').val();
	    	var routingPreference = jQuery(this).find('input[name="routingPreference_planificateur"]:checked').val();

	    	//var datetime = Date.parse(date+' '+time);
            var datetime = dateFromString(date+' '+time);

	    	calculateAndDisplayRoute(depart,arrivee,datetime,routingPreference);
	    });

        function dateFromString(str) {
            var a = str.split(/[^0-9]/);

            return new Date (a[0],a[1]-1,a[2],a[3],a[4] );
        }

	    jQuery('.switchLocation').click(function(e) {
	    	e.preventDefault();
	    	var depart = jQuery('.js-planificateur').find('input[name="lieu_depart"]').val();
	    	var arrivee = jQuery('.js-planificateur').find('input[name="lieu_arrivee"]').val();

	    	jQuery('.js-planificateur').find('input[name="lieu_depart"]').val(arrivee);
	    	jQuery('.js-planificateur').find('input[name="lieu_arrivee"]').val(depart);
	    });

		// Check if we must geolocalize the current position for the planificateur
	    if (jQuery('[name="lieu_depart"]').data('js_get_current_location') == 1 && navigator.geolocation)
	    {
	    	jQuery('[name="lieu_depart"]').parent().find('.js-current_location').click();
	    }

	    // Submit form if the information is already present
	    if (jQuery('input[name="lieu_depart"]').val() && jQuery('input[name="lieu_arrivee"]').val() && jQuery('input[name="date_planificateur"]').val() && jQuery('input[name="time_planificateur"]').val())
	    {
	    	jQuery('.js-planificateur').submit();
	    }

		// var control = document.getElementById('floating-panel');
		// control.style.display = 'block';
		// map.controls[google.maps.ControlPosition.TOP_CENTER].push(control);

		// var onChangeHandler = function() {
		//   calculateAndDisplayRoute(directionsService, directionsDisplay);
		// };
		// document.getElementById('start').addEventListener('change', onChangeHandler);
		// document.getElementById('end').addEventListener('change', onChangeHandler);
	}
}

function zoomToObject(obj, map, bounds = null) {
	// console.log(obj);
	if (bounds == null ) bounds = new google.maps.LatLngBounds();
	var points = obj.getPath().getArray();
	for (var n = 0; n < points.length; n++) {
		bounds.extend(points[n]);
	}

	map.fitBounds(bounds);

	return bounds;
}

function initCircuit()
{
	if (jQuery('.mapCircuit').length > 0)
	{
		var map = new google.maps.Map(jQuery('.mapCircuit')[0], {
			// zoom: 12,
			// center: {lat: 46.354680, lng: -72.583787},
			styles: colors
		});

		var bounds = null;

		var transitLayer = new google.maps.TransitLayer();
        transitLayer.setMap(map);
        // var flightPlanCoordinates = [
        //   {lat: 37.772, lng: -122.214},
        //   {lat: 21.291, lng: -157.821},
        //   {lat: -18.142, lng: 178.431},
        //   {lat: -27.467, lng: 153.027}
        // ];
		var checkbox = document.querySelector('.js-show_weekend');
		// let latlongs = [];
		if(!checkbox || !checkbox.checked){

			if (typeof arr_shapes_lat_lng != 'undefined') {

                for (var i = 0; i < arr_shapes_lat_lng.length; i++) {
                    var routePath = new google.maps.Polyline({
                        path: arr_shapes_lat_lng[i]['shapes'],
                        geodesic: true,
                        strokeColor: '#'+arr_shapes_lat_lng[i]['route_color'],
                        strokeOpacity: 0.8,
                        strokeWeight: 5
					});

                    routePath.setMap(map);
					bounds = zoomToObject(routePath, map, bounds)

				}
            }
		}
		else{
            if (typeof arr_shapes_lat_lng_night != 'undefined') {
                for (var i = 0; i < arr_shapes_lat_lng_night.length; i++) {
                    var routePath = new google.maps.Polyline({
                        path: arr_shapes_lat_lng_night[i]['shapes'],
                        geodesic: true,
                        strokeColor: '#'+arr_shapes_lat_lng_night[i]['route_color'],
                        strokeOpacity: 0.8,
                        strokeWeight: 5
					});

					routePath.setMap(map);
					bounds = zoomToObject(routePath, map, bounds)
                }
            }
		}


		// var transitLayer = new google.maps.TransitLayer();
  // 		transitLayer.setMap(map);

  // 		google.maps.visualRefresh = true;
	}
}

(function ($, root, undefined) {
	$(function () {
		'use strict';

		var lang = $('html').attr('lang').slice(0,2);

		// $('input:radio[name=_contactform_type]:checked').prop('checked', false);
		// $('[name="contactform_type"]').parents('form').hide();

		if ($('#contactform_cite_card_number').length > 0)
		{
			var cleave = new Cleave('#contactform_cite_card_number', {
			    blocks: [1, 3, 3, 3, 3, 3],
			    uppercase: true
			});
		}
		if ($('#contactform_rechargw_card_number').length > 0)
		{
			var cleave = new Cleave('#contactform_rechargw_card_number', {
			    blocks: [1, 3, 3, 3, 3, 3],
			    uppercase: true
			});
		}

        if ($('#contactform_cite_phone_day').length > 0)
        {
            var cleave_phone = new Cleave('#contactform_cite_phone_day', {
                blocks: [3, 3, 4],
                uppercase: true,
                numericOnly: true
            });
        }
        if ($('#contactform_plainte_phone_day').length > 0)
        {
            var cleave_phone = new Cleave('#contactform_plainte_phone_day', {
                blocks: [3, 3, 4],
                uppercase: true,
                numericOnly: true
            });
        }

        if ($('#contactform_plainte_phone_night').length > 0)
        {
            var cleave_phone = new Cleave('#contactform_plainte_phone_night', {
                blocks: [3, 3, 4],
                uppercase: true,
                numericOnly: true
            });
        }

        if ($('#contactform_demande_phone_day').length > 0)
        {
            var cleave_phone = new Cleave('#contactform_demande_phone_day', {
                blocks: [3, 3, 4],
                uppercase: true,
                numericOnly: true
            });
        }

        if ($('#contactform_perdu_phone').length > 0)
        {
            var cleave_phone = new Cleave('#contactform_perdu_phone', {
                blocks: [3, 3, 4],
                uppercase: true,
                numericOnly: true
            });
        }

		if ($('#contactform_plainte_bus_number').length > 0)
		{
			var varcleave_nice = new Cleave('#contactform_plainte_bus_number', {
			    blocks: [4],
			    uppercase: true,
			    numericOnly: true
			});
		}

		$(".datepicker").flatpickr({
		    dateFormat: "Y-m-d",
		    locale: lang,
		    onReady: function(selectedDates, dateStr, instance) {
	    	    if (instance.isMobile) {
	    	    	if ($(instance.element).attr('required')) {
			      		$(instance.mobileInput).attr('required', 'required');
	    	    	}

	    	    	var el = instance.element;
	    	    	var wrap = $(el).closest('.FormElement');

	    	    	$(el).each(function() {
	    	    		el = $(el).next();

	    	    		$(el).on('focus', function() {
							$(wrap).addClass('has-value');
						});

						$(el).on('blur', function() {
							var $this = $(this);

							if(!$this.val()) {
								$(wrap).removeClass('has-value');
							}
						});
					});
			    } else {
			    	$(instance.element).closest('.FormElement').addClass('Flatpickr-active');
			    }
		    },
		    onOpen: function(selectedDates, dateStr, instance){
		    	if (dateStr == '')
		    	{
					var d = new Date(),
					    month = parseInt(d.getMonth()) + 1,
					    day = (d.getDate() < 10) ? "0" + d.getDate() : d.getDate(),
					    year = d.getFullYear();

					    month = (month < 10) ? "0" + month : month;

		    		instance.element.value = year +'-'+ month +'-'+ day;
		    	}
		    }
		});

		$(".timepicker").flatpickr({
		    enableTime: true,
		    noCalendar: true,
		    dateFormat: "H:i",
		    locale: lang,
		    time_24hr: true,
		    onReady: function(selectedDates, dateStr, instance){
	    	    if (instance.isMobile)
	    	    {
	    	    	if ($(instance.element).attr('required'))
	    	    	{
			      		$(instance.mobileInput).attr('required', 'required');
	    	    	}

	    	    	var el = instance.element;
	    	    	var wrap = $(el).closest('.FormElement');

	    	    	$(el).each(function() {
	    	    		el = $(el).next();

	    	    		$(el).on('focus', function() {
							$(wrap).addClass('has-value');
						});

						$(el).on('blur', function() {
							var $this = $(this);

							if(!$this.val()) {
								$(wrap).removeClass('has-value');
							}
						});
					});
			    }
			    else
			    {
			    	$(instance.element).closest('.FormElement').addClass('Flatpickr-active');
			    }
		    },
		    onOpen: function(selectedDates, dateStr, instance){
		    	if (dateStr == '')
		    	{
		    		instance.element.value = '12:00';
		    	}
		    }
		});

		$('.js-closeAlert').click(function(e) {
	        var alert_container = $(this).parents('.Alerts');
	        var expire_time = 5

	        if (alert_container.data('expire_time'))
	        {
	            expire_time = alert_container.data('expire_time');
	        }

	        alert_container.slideUp(300,function () {
	            var expires = "";
	            var date = new Date();
	            date.setTime(date.getTime() + (expire_time*60*1000));
	            expires = "; expires=" + date.toUTCString();

	            document.cookie = "closed_alert=" + date.getTime() + expires + "; path=/";
	        });
	    });

	    $('.readMore_documents').click(function(e) {
	    	var ul_documents = $(this).prev();
	    });

	    $(document).on('click', '.show_map_circuit', function(e) {

			e.preventDefault();
			initCircuit();

	    	$('.mapCircuit').parents('section').first().slideDown(300);
	    	// $('.js-section-map').slideToggle(300);
	    });

        $(document).on('change', '.js-show_weekend', function(e) {

            e.preventDefault();
            initCircuit();
        });


		$('body').on('submit', '.generate_depliant', function(e){
	    	// e.preventDefault();
	    	var html_schedule = encodeURI($('.ListingDataTable')[0].outerHTML);

	    	$(this).append('<input type="hidden" name="html_schedule" value="'+html_schedule+'">');

	    	// return false;
	    });

        $('.DownloadMap .Btn').on('click', function(e) {
            e.preventDefault();
            $(document).find('.generate_depliant').submit();
        });

		$('.js-circuit-horaire').submit(function (e) {
			console.log('asd')
            e.preventDefault();
            var $form = $(this);
            var formData = $form.serialize();
            var contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
            var action = $form.attr('action');

            $.ajax({
                url: '?',
                type: 'POST',
                data: formData,
                processData: true,
                contentType: contentType,
                async: true,
                cache: false,
                beforeSend: function () {
                    $(document).find('.js-loading').show();
                    $(document).find('.ListingDataTable').html('');
                    $(document).find('.BlockCircuits_btns').html('');
                    $(document).find('.mapCircuit').html('');
                    $(document).find('.BlockCircuits_map').hide();
                    $(document).find('.DownloadMap').hide();
					$(document).find('.CheckboxMap').html('');
					$(document).find('.js-download-depliant').html('').hide();
					$(document).find('.js-show-map-button').html('').hide();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $form.unbind('submit');
                    $form.submit();
                },
                success: function (response) {
                    var $page = $(response);
                    $(document).find('.js-loading').hide();
                    $(document).find('.ListingDataTable').html($page.find('.ListingDataTable').html());
                    $(document).find('.BlockCircuits_btns').html($page.find('.BlockCircuits_btns').html());
                    $(document).find('.BlockCircuits_map').html($page.find('.BlockCircuits_map').html());
                    // $(document).find('.generate_depliant').on('submit',setDownload);
					$(document).find('.BlockCircuits_map').hide();

					if ($page.find('.js-show-map-button').length) {
						// $(document).find('.DownloadMap').show();
						$(document).find('.js-show-map-button').html($page.find('.js-show-map-button').html()).show();
                    }
                    if ($page.find('.generate_depliant').length) {
						$(document).find('.DownloadMap').show();
						$(document).find('.js-download-depliant').html($page.find('.js-download-depliant').html()).show();
                    }
                    var tableRows = $('.ListingDataTable_table_row_id');
                    var isPDF = document.getElementsByClassName('BlockPDF');
                    if (tableRows.length > 0 && isPDF.length == 0) {
                        $(tableRows).each(function(){
                            $(this).click(function() {
                                $(this).toggleClass('is-open');
                                $(this).next().slideToggle();
                            });
                        });
                    }
                    initCircuit();
                    action = action.indexOf('?') < 0 ? action + '?' : action;
                    window.history.pushState(formData, "", action + formData);
                },
            });
        });

	    // $('[name="route_id"]').change(function(e) {
	    // 	$('.js-circuit-horaire').submit();
	    // });

	    $('[name="journee_horaire"]').change(function(e) {
			// e.preventDefault();
			// console.log($(this))
			// console.log($(this).attr('data-date'))
			var date = $(this).attr('data-date');

			$('[name="route_id"]:not([data-date="' + date + '"])').hide().attr('disabled', 'disabled').val('');
            $(document).find('.ListingDataTable').html('');
            $(document).find('.BlockCircuits_btns').html('');
            $(document).find('.mapCircuit').html('');
            $(document).find('.BlockCircuits_map').hide();
			$(document).find('.CheckboxMap').html('');
			$(document).find('.generate_depliant').html('');
			$(document).find('.js-show-map-button').html('').hide();


	    	$('[name="route_id"][data-date="'+date+'"]').removeAttr('disabled').show();
	    });

	    $('.Btn-resetForm').click(function(e) {
	    	e.preventDefault();

	    	var form = $(this).closest('form');

	    	form[0].reset();

            $('html,body').on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function() {
                $("html,body").stop();
            });

            $('html,body').animate({
                scrollTop: form.parent().offset().top
            }, 400, function(){
                $("html,body").off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
            });

	    	return false;
	    });

	    $('form.js-itineraire').parsley({
	        trigger:      'submit',
	        successClass: "has-success",
	        errorClass: "has-error",
	        classHandler: function (el) {
	            return el.$element.parent();
	        },
	        errorsWrapper: '<label></label>',
	        errorTemplate: '<span></span>',
	    });
	    $('form.js-planificateur').parsley({
	        trigger:      'submit',
	        successClass: "has-success",
	        errorClass: "has-error",
	        classHandler: function (el) {
	            return el.$element.parent().next();
	        },
	        errorsWrapper: '<label></label>',
	        errorTemplate: '<span></span>',
	    });

	    $('.js-form').parsley({
	        trigger:      'submit',
	        successClass: "has-success",
	        errorClass: "has-error",
	        classHandler: function (el) {

	        	if (el.$element.is(':radio'))
	        	{
	        		return $('input[name="'+el.$element.attr('name')+'"]').parent();
	        	}

	            return el.$element.parent();
	        },
	        errorsContainer: function(parsleyel) {
		        var $err = parsleyel.$element.parent();
		        return $err;
	    	},
	        errorsWrapper: '<span></span>',
	        errorTemplate: '<span></span>',
	    });

  //       $.listen('parsley:field:error', function(){
		//     handle_loading_msg_button($('.js-form'),false);
		// });

		$('.js-itineraire').submit(function (e) {
            e.preventDefault();

			 window.open("https://www.google.com/maps/dir/" + $('#lieu_depart').val() + '/' + $('#lieu_arrivee').val() + '/data=!4m2!4m1!3e3');

			$(".btn-submit-trajet").removeAttr("disabled");
            $(".btn-submit-trajet").removeClass("disabled");
        });

	    $('.js-form').submit(function(e) {

			e.preventDefault();
			e.stopPropagation();
			// return;
	        var form = $(this);

	        var form_data = new FormData(this);

	        var callback_success = form.attr('id')+'_success';

	        if (form.data('callback_success'))
	        {
	        	callback_success = form.data('callback_success');
	        }

	        $('#msg_error').remove();

			var opts = {
			    url: form.attr('action')+'?ajax=1',
			    data: form_data,
			    cache: false,
			    contentType: false,
			    processData: false,
			    type: 'POST',
			    success: function(data){
			        if (!data.error)
		            {
		            	if (typeof window[callback_success] === 'function')
						{
							// alert('callback')
		            		window[callback_success](form,data);
		            	}
		            	else
		            	{
			                form.fadeOut(200, function() {
								// alert('pas callback')

		        	            $('html,body').on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function() {
					                $("html,body").stop();
					            });
// alert('scroll to!!')
					            $('html,body').animate({
									scrollTop: form.parents('section.o-section').offset().top + $('.c-header').height()
					            }, 400, function(){
					                $("html,body").off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
					            });


			                	$(this).before('<div id="msg_success" style="display:none;" class="Alert has-success">'+data.message+'</div>');
			                	$('#msg_success').fadeIn(200);
			                });
		            	}
		            }
		            else
		            {
		            	handle_loading_msg_button($('.js-form'),false);
		            	var errors = data.errors;
						var msg_errors = '';
						if (errors && errors.length) {
							msg_errors = '<ul class="unstyled ListInline-middle">';
							for (var i = errors.length - 1; i >= 0; i--) {
								msg_errors += '<li class="Margin-left-thin has-error">' + errors[i].value + '</li>';
								$("#" + errors[i].key).parent().addClass("has-error");
							}
							msg_errors += '</ul>';
						}

		            	form.before('<div id="msg_error" style="display:none;" class="Alert has-error"><p class="FontWeight-bold has-error">'+data.message+'</p><div>'+msg_errors+'</div></div>');
		            	$('#msg_error').fadeIn(200);

						form.find('.js-form-button-text').text('Envoyer')
						form.find('button.-disabled').removeClass("-disabled")
						$('html,body').animate({
							scrollTop: $('#msg_error').offset().top - $('.c-header').height() - 20
						}, 400, function(){
							$("html,body").off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
						});

		            }
			    }
			};
			if(form_data.fake) {
			    // Make sure no text encoding stuff is done by xhr
			    opts.xhr = function() { var xhr = jQuery.ajaxSettings.xhr(); xhr.send = xhr.sendAsBinary; return xhr; }
			    opts.contentType = "multipart/form-data; boundary="+form_data.boundary;
			    opts.data = form_data.toString();
			}

			$.ajax(opts);


	        // $.post(form.attr('action')+'?ajax=1', form_array, function(data, textStatus, xhr) {
	        //     if (!data.error)
	        //     {
	        //         form.hide().next().append(data.message).show();
	        //     }
	        // });

	        return false;
	    });

	    $('[name="_contactform_type"]').change(function(e) {
	    	var value = $(this).val()
	    	$('[name="contactform_type"]:not([value="'+value+'"])').parents('form').hide();
	    	$('[name="contactform_type"][value="'+value+'"]').parents('form').show();
            $('[name="contactform_type"][value="'+value+'"]').closest('.o-form__wrapper').removeClass('-disabled');
		});

	    $('[name="_contactform_type"]').click(function(e) {
	    	var value = $(this).val()
	    	$('[name="contactform_type"]:not([value="'+value+'"])').parents('form').hide();
	    	$('[name="contactform_type"][value="'+value+'"]').parents('form').show();
            $('[name="contactform_type"][value="'+value+'"]').closest('.o-form__wrapper').removeClass('-disabled');
	    });

	    $('.js-location-input').change(function(e) {
	    	var input_location = $(this);
	    	if(input_location.val() != '')
	    	{
	    		if ($('.js-planificateur').length > 0)
	    		{
	    			$('.js-planificateur').find('.error-custom').remove();
	    		}
	    		else
	    		{
	    			input_location.siblings('.form-error').find('.error-custom').remove()
	    		}
	    	}
	    });

		$('.js-current_location').click(function(e) {

			var input_location = $(this).parent().find('input').first();
			var div_location_loader = $(this).parent().find('.current_location_loader');

			if (navigator.geolocation)
			{
				div_location_loader.addClass('is-loading').show();


	          	navigator.geolocation.getCurrentPosition(function(position) {
		            input_location.siblings('.form-error').empty();
		            var pos = {
		              lat: position.coords.latitude,
		              lng: position.coords.longitude
		            };

	            	var geocoder = new google.maps.Geocoder;

	                geocoder.geocode({'location': pos}, function(results, status) {

			          if (status === 'OK')
			          {

			            if (results[0])
			            {
							input_location.val(results[0].formatted_address).change();
			            	var callback_success = input_location.data('callback_success');
			            	if (typeof window[callback_success] === 'function')
			            	{
			            		window[callback_success]();
			            	}
			            }
			            else
			            {
			              //alert('Aucun résultat trouvé.');
			              input_location.parent().find('.error-custom').remove();
			              input_location.parent().find('.form-error').remove().append('<label class="filled error-custom"><span class="parsley-required">'+message_error_geolocation_no_results+'</span></label>');
			            }
			          }
			          else
			          {
			            //alert('Un problème est survenue lors de la géolocalisation: ' + status);
			            input_location.parent().find('.error-custom').remove();
			            input_location.parent().find('.form-error').remove().append('<label class="filled error-custom"><span class="parsley-required">'+message_error_geolocation+'</span></label>');
			          }

			          setTimeout(function() {
			          	div_location_loader.removeClass('is-loading').hide();
			          }, 250);
			        });

		          }, function() {
		          	div_location_loader.removeClass('is-loading').hide();
		          	input_location.parent().find('.error-custom').remove();
		          	input_location.parent().find('.form-error').append('<label class="filled error-custom"><span class="parsley-required">'+message_error_geolocation+'</span></label>');
		            //alert('Une erreur est survenue lors de la géolocalisation.');
		          },{
					  enableHighAccuracy: true,
					  timeout: 5000,
					  maximumAge: 120000
				});


	        }
	        else
	        {
	          // Browser doesn't support Geolocation
	         // alert('Votre navigateur ne supporte pas la Géolocalisation.');
	        }

		});

		// when upload a file, get it's name and display it in the label
		$('input[type="file"]').change(function (e) {
		    var fileName = e.target.files[0].name;

		    $(this).parent().find('label').text(fileName);
		});

		// when submiting a form, disable the button and show "sending..." in in
		$('form:not(.js-planificateur,.js-itineraire)').submit(function (e) {
		    handle_loading_msg_button($(this),true);
		});

		// var x = document.getElementById("demo");

		// function getLocation() {
		//     if (navigator.geolocation) {
		//         navigator.geolocation.getCurrentPosition(showPosition);
		//     } else {
		//         x.innerHTML = "Geolocation is not supported by this browser.";
		//     }


		tippy('.btn_tarif_information,.btn_plainte_bus_number_information,.btn_cite_no_carte_information',{
			trigger: 'click',
			animation: 'scale',
			arrow: true,
			theme: 'sttr',
			maxWidth: '600px'
		});

		if ($('[name="type_depositaires"]').length > 0)
		{
			$('[name="type_depositaires"]').change(function(event) {
				var tab_linked = $(this).data('tab_linked');

				$('div[id^="depositaires"]:not(div'+tab_linked+')').fadeOut(100, function() {
					$(tab_linked).fadeIn(100);

				});

			});
		}

		if ($('[name="depositaires"]').length > 0)
		{
			$('[name="depositaires"]').change(function(event) {
				var marker_key = $(this).val();
				var map_index = $('.Map').index($(this).closest('.Depositaires').find('.Map'));
				var marker_selected = google_marker_collection[map_index][marker_key];

				if (marker_key != '')
				{
					google.maps.event.trigger(marker_selected, 'click');
				}
				else
				{
					current_infoWindow.close();
				}

			});
		}

		if ($('.Depositaires_header_radios').length > 0)
		{
			$('.Depositaires_header_radios input').change(function(e) {
				var value = $(this).val();
				if (value == 'list')
				{
					$('.Depositaires_header_select').hide();
				}
				else
				{
					$('.Depositaires_header_select').show();
				}
			});
		}

		$(document).ready(function($) {
		    if ($('input[name="lieu_depart"]').val() || $('input[name="lieu_arrivee"]').val())
		    {
		    	$(document).scrollTop( $(".Planificateur_header").offset().top );
		    }
		});


		$('body').on('change input blur', 'input, textarea', function () {
			if ($(this).val() != "") $(this).addClass('-filled');
			if ($(this).val() == "") $(this).removeClass('-filled');
		})



	});
})(jQuery, this);

var setDownload = function(e) {

    var table = document.querySelector('.ListingDataTable');
    if (table && table.children) {
        var html_schedule = encodeURI(table.outerHTML);
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = "html_schedule";
        input.value = html_schedule;
        this.appendChild(input);


    }
}

window.addEventListener('DOMContentLoaded', function(event) {

	var depliant = document.querySelector('.generate_depliant');
	if(depliant){
        depliant.addEventListener('submit',setDownload);


	}

    /* $('.generate_depliant').submit(function(e) {
           // e.preventDefault();
           var html_schedule = encodeURI($('.ListingDataTable')[0].outerHTML);

           $(this).append('<input type="hidden" name="html_schedule" value="'+html_schedule+'">');

           // return false;
       });*/
});
